import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Select from 'react-select';
import DeepEqual from 'fast-deep-equal';
import AsyncSelect from 'react-select/async';
import Geosuggest from '@ubilabs/react-geosuggest';
import Badges from './Badges';
import KeywordSearchInput from '../KeywordSearch';
import SliderSearchInput from '../SliderSearchInput';
import { analyticsTrack } from '../../../analyticsUtils';
import { SELECT_INPUTS, ASYNC_INPUTS, SLIDER_INPUTS, GEOFILTER_INPUTS, TEXT_INPUTS, CHECKBOX_INPUTS } from './constants';
var SearchMenuItem = /*#__PURE__*/function (_PureComponent) {
  function SearchMenuItem(props) {
    var _this;
    _classCallCheck(this, SearchMenuItem);
    _this = _callSuper(this, SearchMenuItem, [props]);
    _this.state = {
      isActive: false,
      selections: 0
    };
    _this.renderSubcontent = _this.renderSubcontent.bind(_this);
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.extractSelectionData = _this.extractSelectionData.bind(_this);
    return _this;
  }
  _inherits(SearchMenuItem, _PureComponent);
  return _createClass(SearchMenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.extractSelectionData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        name = _this$props.name,
        selectionData = _this$props.selectionData;
      var areSelectionsEqual = DeepEqual(selectionData[name], prevProps.selectionData[name]);
      if (!areSelectionsEqual) this.extractSelectionData();
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      var name = this.props.name;
      var isActive = this.state.isActive;
      this.setState({
        isActive: !isActive
      }, function () {
        if (!isActive) {
          analyticsTrack("Clicked to open ".concat(name, " tab"), {
            location: 'Search Index'
          });
        }
      });
    }
  }, {
    key: "extractSelectionData",
    value: function extractSelectionData() {
      var _this$props2 = this.props,
        name = _this$props2.name,
        selectionData = _this$props2.selectionData;
      var isActive = this.state.isActive;
      var selections = Object.entries(selectionData[name]).reduce(function (prev, curr) {
        var isCheckbox = typeof curr[1] === 'boolean';
        var isSlider = curr[0] === 'Hourly Rate' || curr[0] === 'Years of Experience';
        var isKeywordOrRole = curr[0] === 'Keyword' || curr[0] === 'Role';
        if (isKeywordOrRole && typeof curr[1] === 'string' || isCheckbox && curr[1] || isSlider && curr[1].length > 1) return prev + 1;
        if (isKeywordOrRole && _typeof(curr[1]) === 'object' || isCheckbox && !curr[1]) return prev;
        return prev + curr[1].length;
      }, 0);
      if (selections > 0) {
        this.setState(_objectSpread({}, !isActive && {
          isActive: true
        }));
      }
      this.setState({
        selections: selections
      });
      if (name === 'Role') {
        this.setState({
          isActive: true
        });
      }
    }
  }, {
    key: "renderSubcontent",
    value: function renderSubcontent() {
      var _this2 = this;
      var _this$props3 = this.props,
        name = _this$props3.name,
        structuralData = _this$props3.structuralData,
        selectionData = _this$props3.selectionData,
        handleSelection = _this$props3.handleSelection,
        handleChange = _this$props3.handleChange,
        setSelectionState = _this$props3.setSelectionState,
        registerSliderResetFunction = _this$props3.registerSliderResetFunction;
      return /*#__PURE__*/React.createElement(Fragment, null, Object.entries(structuralData).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          submenuTitle = _ref2[0],
          options = _ref2[1];
        var isSelectInput = SELECT_INPUTS.includes(submenuTitle);
        var isGeoInput = GEOFILTER_INPUTS.includes(submenuTitle);
        var isAsyncInput = ASYNC_INPUTS.includes(submenuTitle);
        var isSliderInput = SLIDER_INPUTS.includes(submenuTitle);
        var isCheckbox = CHECKBOX_INPUTS.includes(submenuTitle);
        var isTextInput = TEXT_INPUTS.includes(submenuTitle);
        if (submenuTitle === 'Keyword') {
          return /*#__PURE__*/React.createElement(KeywordSearchInput, {
            key: submenuTitle,
            name: name,
            selectionData: selectionData,
            submenuTitle: submenuTitle,
            handleChange: handleChange,
            setSelectionState: setSelectionState
          });
        }
        if (isSelectInput) {
          var doesInputHaveSelections = selectionData[name][submenuTitle].length > 0;
          return /*#__PURE__*/React.createElement(Fragment, {
            key: submenuTitle
          }, /*#__PURE__*/React.createElement("div", {
            className: "subcontent-title"
          }, submenuTitle === 'Role' ? 'Search by role' : submenuTitle), /*#__PURE__*/React.createElement(Select, {
            placeholder: "Type ".concat(submenuTitle),
            options: options,
            className: "basic-multi-select",
            classNamePrefix: "select",
            value: doesInputHaveSelections ? selectionData[name][submenuTitle].map(function (selection) {
              return options.find(function (option) {
                return option.label === selection;
              });
            }) : [],
            onChange: function onChange(val) {
              return handleSelection(name, val, submenuTitle);
            },
            isMulti: true
          }));
        }
        if (isAsyncInput) {
          var _doesInputHaveSelections = selectionData[name][submenuTitle].length > 0;
          return /*#__PURE__*/React.createElement(Fragment, {
            key: submenuTitle
          }, /*#__PURE__*/React.createElement("div", {
            className: "subcontent-title"
          }, submenuTitle), /*#__PURE__*/React.createElement(AsyncSelect, {
            placeholder: "Search ".concat(submenuTitle),
            loadOptions: function loadOptions(input) {
              return _this2.constructor.getOptions(input, submenuTitle);
            },
            value: _doesInputHaveSelections ? selectionData[name][submenuTitle].map(function (selection) {
              return {
                label: selection,
                value: selection
              };
            }) : selectionData[name][submenuTitle],
            onChange: function onChange(val) {
              return handleSelection(name, val, submenuTitle);
            },
            closeOnSelect: false,
            closeMenuOnSelect: false,
            onSelectResetsInput: false,
            className: "basic-multi-select",
            isMulti: true,
            cacheOptions: true
          }));
        }
        if (isSliderInput) {
          var defaultValue = selectionData[name][submenuTitle].length > 0 ? selectionData[name][submenuTitle] : options;
          return /*#__PURE__*/React.createElement(SliderSearchInput, {
            key: submenuTitle,
            name: name,
            submenuTitle: submenuTitle,
            defaultValue: defaultValue,
            handleChange: handleChange,
            options: options,
            registerSliderResetFunction: registerSliderResetFunction
          });
        }
        if (isGeoInput) {
          return /*#__PURE__*/React.createElement(Fragment, {
            key: submenuTitle
          }, /*#__PURE__*/React.createElement("div", {
            className: "subcontent-title"
          }, submenuTitle), /*#__PURE__*/React.createElement("div", {
            className: "filter-geosuggest"
          }, /*#__PURE__*/React.createElement(Geosuggest, {
            initialValue: selectionData[name][submenuTitle][0] || '',
            inputClassName: "form-control",
            types: ['(cities)'],
            onSuggestSelect: function onSuggestSelect(obj) {
              return handleSelection(name, "".concat(obj.location.lat, ", ").concat(obj.location.lng), submenuTitle);
            }
          })));
        }
        if (isCheckbox) {
          return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "subcontent-title"
          }, submenuTitle), /*#__PURE__*/React.createElement("label", {
            className: "custom-checkbox-container",
            htmlFor: submenuTitle
          }, /*#__PURE__*/React.createElement("input", {
            type: "checkbox",
            id: submenuTitle,
            checked: selectionData[name][submenuTitle],
            onChange: function onChange() {
              if (!selectionData[name][submenuTitle]) {
                analyticsTrack("Checked ".concat(submenuTitle), {
                  location: 'Search Index'
                });
              }
              handleChange(name, submenuTitle, !selectionData[name][submenuTitle]);
            }
          }), /*#__PURE__*/React.createElement("span", {
            className: "checkmark"
          }), /*#__PURE__*/React.createElement("span", {
            className: "label filter-text"
          }, "Available now")));
        }
        if (isTextInput) {
          return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "subcontent-title"
          }, submenuTitle), /*#__PURE__*/React.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: "Type ".concat(submenuTitle, "s"),
            value: selectionData[name][submenuTitle] || '',
            onChange: function onChange(event) {
              if (selectionData[name][submenuTitle] && selectionData[name][submenuTitle].length >= 2) {
                analyticsTrack("Filtered by ".concat(submenuTitle), {
                  location: 'Search Index'
                });
              }
              handleChange(name, submenuTitle, event.target.value);
            }
          }));
        }
        return /*#__PURE__*/React.createElement(Badges, {
          key: submenuTitle,
          submenuTitle: submenuTitle,
          menuItemTitle: name,
          options: options,
          selections: selectionData,
          handleSelection: handleSelection
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isActive = _this$state.isActive,
        selections = _this$state.selections;
      var name = this.props.name;
      return /*#__PURE__*/React.createElement("div", {
        className: "menu-filter-item"
      }, /*#__PURE__*/React.createElement("div", {
        id: name,
        className: "item-header",
        role: "link",
        tabIndex: 0,
        onClick: this.handleToggle
      }, /*#__PURE__*/React.createElement("div", {
        className: "item-title demibold"
      }, name, selections > 0 && /*#__PURE__*/React.createElement("span", {
        className: "normal-weight"
      }, "".concat(selections, " Selected"))), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-chevron-".concat(isActive ? 'up' : 'down')
      })), isActive && /*#__PURE__*/React.createElement("div", {
        className: "item-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "subcontent"
      }, this.renderSubcontent())));
    }
  }], [{
    key: "getOptions",
    value: function getOptions(input, submenuTitle) {
      var asyncUrl = submenuTitle === 'Diseases' ? '/users/autocomplete_disease_code' : '/languages/autocomplete_dropdown';
      return axios.get(asyncUrl, {
        params: {
          term: input
        }
      }).then(function (response) {
        if (submenuTitle === 'Languages') {
          return response.data.map(function (language) {
            return {
              label: language.text,
              value: language.id
            };
          });
        }
        return response.data;
      });
    }
  }]);
}(PureComponent);
SearchMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSelection: PropTypes.func.isRequired,
  structuralData: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]).isRequired,
  selectionData: PropTypes.shape({}).isRequired,
  setSelectionState: PropTypes.func.isRequired,
  registerSliderResetFunction: PropTypes.func.isRequired
};
export default SearchMenuItem;